import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, option_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";

export class Agreement extends Record {
    constructor(ContractNrs, Filename, InternalFilename, UploadedBy, Uploadedutc) {
        super();
        this.ContractNrs = ContractNrs;
        this.Filename = Filename;
        this.InternalFilename = InternalFilename;
        this.UploadedBy = UploadedBy;
        this.Uploadedutc = Uploadedutc;
    }
}

export function Agreement$reflection() {
    return record_type("Containers.Agreements.Model.Agreement", [], Agreement, () => [["ContractNrs", option_type(string_type)], ["Filename", string_type], ["InternalFilename", string_type], ["UploadedBy", string_type], ["Uploadedutc", string_type]]);
}

